// extracted by mini-css-extract-plugin
export default {"systemThumbnail":"qR1SU2"};